import axios from 'axios'

const rawBase = (import.meta.env.VITE_API_BASE_URL as string) || ''
// 绝对 URL（开发直连后端）→ 拼接 /api/v1；空/相对路径（Docker 同域）→ /api/v1
const baseURL = rawBase.startsWith('http') ? `${rawBase}/api/v1` : '/api/v1'
export const API_BASE = rawBase || window.location.origin
export const WS_BASE = API_BASE.replace(/^http/, 'ws')

const client = axios.create({
  baseURL,
  timeout: 60000,
})

// 保存待刷新的请求
let isRefreshing = false
let failedQueue: Array<{
  resolve: (token: string) => void
  reject: (err: unknown) => void
}> = []

function processQueue(error: unknown, token: string | null = null) {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error)
    } else {
      resolve(token!)
    }
  })
  failedQueue = []
}

// 请求拦截器：自动注入 JWT Token
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('ai-iot-auth')
    if (token) {
      try {
        const parsed = JSON.parse(token)
        if (parsed.state?.accessToken) {
          config.headers.Authorization = `Bearer ${parsed.state.accessToken}`
        }
      } catch {
        // ignore parse errors
      }
    }
    return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截器：处理 401 自动刷新 Token
client.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config
    const msg = err.response?.data?.message || err.message || '请求失败'

    // 不是 401 或已经是刷新请求，直接拒绝
    if (err.response?.status !== 401 || originalRequest.url?.includes('/auth/')) {
      return Promise.reject(new Error(msg))
    }

    // 已经在刷新中，排队等待
    if (isRefreshing) {
      return new Promise<string>((resolve, reject) => {
        failedQueue.push({ resolve, reject })
      }).then((token) => {
        originalRequest.headers.Authorization = `Bearer ${token}`
        return client(originalRequest)
      })
    }

    isRefreshing = true
    originalRequest._retry = true

    try {
      const stored = localStorage.getItem('ai-iot-auth')
      let refreshToken = ''
      if (stored) {
        const parsed = JSON.parse(stored)
        refreshToken = parsed.state?.refreshToken || ''
      }

      const { data } = await axios.post(`${API_BASE}/api/v1/auth/refresh`, {
        refresh_token: refreshToken,
      })

      // 更新 localStorage 中的 token
      if (stored) {
        const parsed = JSON.parse(stored)
        parsed.state.accessToken = data.access_token
        parsed.state.refreshToken = data.refresh_token
        localStorage.setItem('ai-iot-auth', JSON.stringify(parsed))
      }

      processQueue(null, data.access_token)
      originalRequest.headers.Authorization = `Bearer ${data.access_token}`
      return client(originalRequest)
    } catch (refreshError) {
      processQueue(refreshError, null)
      // 刷新失败，清除 auth 状态
      localStorage.removeItem('ai-iot-auth')
      window.location.href = '/login'
      return Promise.reject(new Error('登录已过期，请重新登录'))
    } finally {
      isRefreshing = false
    }
  }
)

export default client
